module.exports = __webpack_public_path__ + "img/none.c70a4b01.jpg";